import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Trash18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M8.25 7L8.25 13H9.75L9.75 7H8.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.25 3.25H2V4.75H3.30987L4.21436 15.6038C4.26835 16.2517 4.80993 16.75 5.46004 16.75H12.5399C13.19 16.75 13.7316 16.2517 13.7856 15.6038L14.6901 4.75H16V3.25H11.75C11.75 2.42613 11.5454 1.65628 10.9445 1.05545C9.88542 -0.00367373 8.11458 -0.00367373 7.05546 1.05545C6.45463 1.65628 6.25 2.42613 6.25 3.25ZM8.11612 2.11611C7.79907 2.43316 7.75 2.82754 7.75 3.25H10.25C10.25 2.82754 10.2009 2.43316 9.88388 2.11611C9.40246 1.63469 8.59754 1.63469 8.11612 2.11611ZM13.1849 4.75H4.81507L5.69007 15.25H12.3099L13.1849 4.75Z'
      fill='currentColor'
    />
  </Svg>
);

Trash18.displayName = 'Trash18';
export default Trash18;
